<div class="tw-relative tw-flex tw-flex-col tw-px-4 sm:tw-px-10 tw-pt-8 sm:tw-pt-6 tw-pb-6 sm:tw-pb-8 tw-select-none tw-font-['Rubik']">

  <div class="sm:tw-hidden tw-absolute tw-top-2 tw-right-2">
    <i class="far fa-times tw-cursor-pointer tw-text-2xl tw-text-gray-500" (click)="close()"></i>
  </div>

  <h1 class="tw-text-[20px] sm:tw-text-[24px] tw-font-bold tw-text-black tw-text-center tw-leading-[24px] sm:tw-leading-[28px] tw-mt-0 sm:tw-mt-4">
    🎉 {{ 'followup.summary.whatsapp_modal.title' | translate }}
  </h1>

  <p class="tw-text-[15px] sm:tw-text-[18px] tw-font-normal tw-text-black tw-text-center tw-mt-3 sm:tw-mt-4 tw-leading-[20px] sm:tw-leading-[22px] tw-px-2 sm:tw-px-8">
    {{ 'followup.summary.whatsapp_modal.subtitle' | translate: { date: data.activationDate } }}
  </p>

  <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-4 sm:tw-gap-8 tw-mt-4 sm:tw-mt-5 tw-items-center lg:tw-items-start tw-justify-center">
    <div class="tw-flex tw-justify-center tw-items-start">
      <img
        src="https://statics.myhotel.io/uploads/fidelity-suite/whatsapp/wsp-modal.png"
        alt="WhatsApp Preview"
        class="tw-w-[200px] sm:tw-w-[280px] tw-h-auto"
      />
    </div>

    <div class="tw-flex tw-flex-col tw-max-w-[380px]">
      <h2 class="tw-text-[15px] sm:tw-text-[16px] tw-font-medium tw-text-black tw-mb-3 sm:tw-mb-4 tw-text-center lg:tw-text-left">
        {{ 'followup.summary.whatsapp_modal.how_it_works' | translate }}
      </h2>

      <ul class="tw-flex tw-flex-col tw-gap-3 sm:tw-gap-4">
        <li class="tw-flex tw-gap-2 tw-text-[13px] sm:tw-text-[14px] tw-font-normal tw-text-black tw-leading-[18px] sm:tw-leading-[20px]">
          <span class="tw-flex-shrink-0">✅</span>
          <span>{{ 'followup.summary.whatsapp_modal.benefit_1' | translate }}</span>
        </li>
        <li class="tw-flex tw-gap-2 tw-text-[13px] sm:tw-text-[14px] tw-font-normal tw-text-black tw-leading-[18px] sm:tw-leading-[20px]">
          <span class="tw-flex-shrink-0">✅</span>
          <span>{{ 'followup.summary.whatsapp_modal.benefit_2' | translate }}</span>
        </li>
        <li class="tw-flex tw-gap-2 tw-text-[13px] sm:tw-text-[14px] tw-font-normal tw-text-black tw-leading-[18px] sm:tw-leading-[20px]">
          <span class="tw-flex-shrink-0">✅</span>
          <span>{{ 'followup.summary.whatsapp_modal.benefit_3' | translate }}</span>
        </li>
        <li class="tw-flex tw-gap-2 tw-text-[13px] sm:tw-text-[14px] tw-font-normal tw-text-black tw-leading-[18px] sm:tw-leading-[20px]">
          <span class="tw-flex-shrink-0">✅</span>
          <span>{{ 'followup.summary.whatsapp_modal.benefit_4' | translate: { date: data.activationDate } }}</span>
        </li>
      </ul>
    </div>
  </div>

  <div class="tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-center tw-gap-3 sm:tw-gap-4 tw-mt-6 sm:tw-mt-8 tw-px-4 sm:tw-px-0">
    <div [mhTooltip]="!canPerformActions ? ('followup.summary.whatsapp_modal.admin_required_tooltip' | translate) : ''" position="above">
      <mh-core-lib-button
        [isSecondary]="true"
        [isDisabled]="!canPerformActions"
        [text]="'followup.summary.whatsapp_modal.reject_button' | translate"
        [height]="35"
        [customClass]="'!tw-shadow-none !tw-min-w-[204px]'"
        [textClass]="'!tw-text-[14px] sm:!tw-text-[16px] !tw-font-normal'"
        (clicked)="onRejectGift()"
      ></mh-core-lib-button>
    </div>

    <div [mhTooltip]="!canPerformActions ? ('followup.summary.whatsapp_modal.admin_required_tooltip' | translate) : ''" position="above">
      <mh-core-lib-button
        [isPrimary]="true"
        [isDisabled]="!canPerformActions"
        [text]="'followup.summary.whatsapp_modal.activate_button' | translate"
        [height]="35"
        [customClass]="'!tw-shadow-none !tw-min-w-[204px]'"
        [textClass]="'!tw-text-[14px] sm:!tw-text-[16px] !tw-font-normal'"
        (clicked)="onActivateNow()"
      ></mh-core-lib-button>
    </div>
  </div>
</div>
